module.exports = __webpack_public_path__ + "img/237a3f1c0c7b4f6db33832af0b68a50.008d38e6.png";